import { Logger } from '~~/helpers/logger';

import type { RecommendationTypeName } from '~~/types/localization/localizationHelperTypes';
import { errorToString } from '~~/helpers/error/errorToString';
import type { LastSeenProduct } from '~~/types/product/LastSeenProduct';
import type { TagProductBox } from '~~/types/integrations/tagManager/TagProductBox';
import {
  prepareClickProductBoxTags,
} from '~/plugins/integrations/tagManager/helpers/transformers';

export const useRecommendationEvent = (
  { recommendationType }: { recommendationType?: RecommendationTypeName } = {},
) => {

  const { trackRecommendationsShown } = useGtmEvents();

  const logIntegrationError = (forIntegration: string, error: string) => {

    Logger.error(`${forIntegration} error: ${error}`);
  
  };

  const triggerGtmRecommendationEvent = ({
    lastSeenProducts,
  }: {
    lastSeenProducts?: LastSeenProduct[]
  }) => {

    try {

      let productsTags: TagProductBox[] = [];

      if (lastSeenProducts?.length) {

        productsTags = lastSeenProducts
          .map(lastSeenProduct => prepareClickProductBoxTags(lastSeenProduct));
      
      }
      trackRecommendationsShown(productsTags, recommendationType);
    
    } catch (error: unknown) {

      logIntegrationError('gtm|triggerGtmRecommendationEvent', errorToString(error));
    
    }
  
  };

  return {
    triggerGtmRecommendationEvent,
  };

};
